import { render } from "./CookiesImageViewer.vue?vue&type=template&id=fffde17a&scoped=true&ts=true"
import script from "./CookiesImageViewer.vue?vue&type=script&lang=ts"
export * from "./CookiesImageViewer.vue?vue&type=script&lang=ts"

import "./CookiesImageViewer.vue?vue&type=style&index=0&id=fffde17a&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffde17a"]])

export default __exports__